import { render } from "./OrderReferenceField.vue?vue&type=template&id=5d92f116&scoped=true&ts=true"
import script from "./OrderReferenceField.vue?vue&type=script&lang=ts"
export * from "./OrderReferenceField.vue?vue&type=script&lang=ts"

import "./OrderReferenceField.vue?vue&type=style&index=0&id=5d92f116&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.27_vue@3.5.27_typescript@5.9.3__webpack@5.105.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d92f116"]])

export default __exports__